import { getStore } from '../store/Store';
import { getMLColumnHeaderDefaultWidths } from '../utils/getMLColumnHeaderDefaultWidths';
import { isGlobalFeatureEnabled } from 'owa-feature-flags';
import type MailListColumnHeaderType from '../types/MailListColumnHeaderType';
import { getReceivedColumnMinWidth } from '../utils/getColumnMinWidth';
import { isReadingPanePositionRight } from './readingPanePosition';
import {
    LV_SCROLLBAR_WIDTH,
    MCL_TWISTY_PERSONA_CONTAINER_WIDTH,
    MCL_TWISTY_PERSONA_ROOMY_CONTAINER_WIDTH,
    MCL_UNREAD_BAR_WIDTH,
    MCL_TWISTY_WIDTH_NO_CHECKBOX,
} from '../mailLayoutConstants';
import { getDensityModeString } from 'owa-fabric-theme';

// This function adjusts the column widths stored in the store to account for various
// UI differences between the column header and the actual listview columns.
export default function getListViewColumnWidths(
    areCheckboxesHidden: boolean,
    sortColumnHeaderType?: MailListColumnHeaderType
): {
    senderColumnWidth: number;
    subjectColumnWidth: number;
    receivedColumnWidth: number;
    sortedContentColumnWidth: number;
} {
    const defaultColumnWidths = getMLColumnHeaderDefaultWidths(sortColumnHeaderType);

    let senderColumnWidth = getStore().senderColumnWidth || defaultColumnWidths.senderColumnWidth;
    const subjectColumnWidth =
        getStore().subjectColumnWidth || defaultColumnWidths.subjectColumnWidth;
    let receivedColumnWidth =
        getStore().receivedColumnWidth || defaultColumnWidths.receivedColumnWidth;
    const sortedContentColumnWidth =
        getStore().sortedContentColumnWidth || defaultColumnWidths.sortedContentColumnWidth;

    // adjust for unread bar and, when multiline preview is active, the twisty/persona
    // that moves outside the sender column:

    const twistyPersonaContainerWidth =
        getDensityModeString() === 'full'
            ? MCL_TWISTY_PERSONA_ROOMY_CONTAINER_WIDTH
            : MCL_TWISTY_PERSONA_CONTAINER_WIDTH;
    senderColumnWidth -=
        MCL_UNREAD_BAR_WIDTH +
        (areCheckboxesHidden
            ? MCL_TWISTY_WIDTH_NO_CHECKBOX
            : isGlobalFeatureEnabled('tri-mlMultiLinePreview')
            ? twistyPersonaContainerWidth
            : 0);
    // Width in store is calculated from the column header which will always be LV_SCROLLBAR_WIDTH greater than the size of the column in the listview.
    receivedColumnWidth -= LV_SCROLLBAR_WIDTH;
    // enforce min width for listview column
    const minReceivedWidth = getReceivedColumnMinWidth(
        false /* isColumnHeader */,
        isReadingPanePositionRight()
    );
    // Enforce min received column width in listview
    if (receivedColumnWidth < minReceivedWidth) {
        receivedColumnWidth = minReceivedWidth;
    }

    return {
        senderColumnWidth,
        subjectColumnWidth,
        receivedColumnWidth,
        sortedContentColumnWidth,
    };
}
